export class NewsPriorityReferenceModel {
    newsPriorityCode: string;
    newsPriorityName: string;
}